import { useEffect, useState } from 'react';
import {
  getPageCount,
  shouldResetPage,
  sliceClientPage,
} from '../utils/portfolioTabPagination';

export function usePositionsPagination<T>(
  rows: readonly T[],
  pageSize: number,
): {
  pagedRows: T[];
  page: number;
  setPage: (page: number) => void;
  totalPages: number;
} {
  const [page, setPage] = useState(1);
  const totalPages = getPageCount(rows.length, pageSize);
  const pagedRows = sliceClientPage(rows, page, pageSize);

  useEffect(() => {
    if (shouldResetPage(page, totalPages)) {
      setPage(1);
    }
  }, [totalPages, page]);

  return { pagedRows, page, setPage, totalPages };
}
